import { createAction } from 'redux-actions';
import { POST_TERCERO_PASSUDP } from '../constants'
import { apiPost } from '../api'
import { postTerceroPassUdpUrl } from '../api/urls'

export const postTerceroPassUdp = createAction(POST_TERCERO_PASSUDP,
    (datos) => apiPost(postTerceroPassUdpUrl, datos)());